import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import type { RowData } from '@tanstack/react-table';

import { TooltipProvider } from './components/ui/tooltip';
import { UserProvider, useUser } from './providers/user-provider';
import { routeTree } from './routeTree.gen';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } },
  queryCache: new QueryCache({}),
});

const router = createRouter({
  routeTree,
  // defaultPreload: 'intent',
  // defaultPreloadStaleTime: 0,
  context: { queryClient, auth: null, setOrganizationId: () => {} },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

declare module '@tanstack/react-table' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface ColumnMeta<TData extends RowData, TValue> {
    className: string;
  }
}

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <TooltipProvider>
          <InnerApp />
        </TooltipProvider>
      </UserProvider>
    </QueryClientProvider>
  );
};

const InnerApp = () => {
  const { session, setOrganizationId } = useUser();

  return (
    <>
      <RouterProvider router={router} context={{ auth: session, setOrganizationId, queryClient }} />
      <ReactQueryDevtools initialIsOpen={false} />
    </>
  );
};

export default App;
